import { render, staticRenderFns } from "./scope104.vue?vue&type=template&id=a07fdcb2&scoped=true"
import script from "./scope104.vue?vue&type=script&lang=js"
export * from "./scope104.vue?vue&type=script&lang=js"
import style0 from "./scope104.vue?vue&type=style&index=0&id=a07fdcb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07fdcb2",
  null
  
)

export default component.exports